module.exports = __webpack_public_path__ + "img/million_read.9fc2678c.png";